import { AxiosError } from 'axios';

export const isAbortError = (error: unknown): boolean => {
  if (!error) return false;
  const err = error as AxiosError;

  return (
    err.code === 'ECONNABORTED' ||
    err.code === 'ERR_CANCELED' ||
    err.name === 'CanceledError' ||
    err.message === 'canceled'
  );
};
